import { makeStyles } from "@mui/styles";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import React from "react";
import { useSelector } from "react-redux";
import { selectUserSession } from "../slices/userSession/userSessionSlice";
import { TIME_OFF_PAGE_TYPE } from "../util/constants";
import { getUnionContractGivenJobCode } from "../util/workgroupMapper.js";
import PropTypes from "prop-types";
import { TOR_SUBMISSION_HOLD_REQUEST_REMINDER } from "../util/timeOffRequestUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "auto",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const UnionContractHoldRequestReminder = (props) => {
  const userSession = useSelector(selectUserSession);
  const classes = useStyles();

  const renderHoldRequestWarning = () => {
    switch (props.pageType) {
      case TIME_OFF_PAGE_TYPE:
        return (
          <>
            <Alert severity="warning">
              <AlertTitle>
                <strong>
                  {
                    TOR_SUBMISSION_HOLD_REQUEST_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)][
                      props.timeOffType
                    ].warningContent[props.isTimeOffRequestCancelAction ? "cancelHeader" : "header"]
                  }
                </strong>
              </AlertTitle>
              {
                TOR_SUBMISSION_HOLD_REQUEST_REMINDER[getUnionContractGivenJobCode(userSession.jobCode)][
                  props.timeOffType
                ].warningContent["message"]
              }
            </Alert>
          </>
        );
      default:
        return "Missing Page Type, check UnionContractHoldRequestReminder.jsx";
    }
  };

  return (
    <div className={classes.root} data-testid="union-contract-hold-request-reminder">
      {renderHoldRequestWarning()}
    </div>
  );
};

UnionContractHoldRequestReminder.propTypes = {
  pageType: PropTypes.string.isRequired,
  timeOffType: PropTypes.string,
  isTimeOffRequestCancelAction: PropTypes.bool,
};

UnionContractHoldRequestReminder.defaultProps = {
  isTimeOffRequestCancelAction: false,
};

export default UnionContractHoldRequestReminder;
